import { combineReducers } from 'redux';
import current from './currentArea';
import update from './updateAreaReducer';
import data from './getAreasReducer';
import add from './addAreaReducer';
import remove from './removeAreaReducer';
import currentArea from './getAreaReducer';


const rootReducer = combineReducers({
    current,
    update, 
    data, 
    add,
    remove,
    currentArea
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/index.js